/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-09T15:13:19.205
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveDepositContractTemplate,
	getDepositContractTemplateCreateInit,
	getDepositContractTemplateEditInit,
	getDepositContractTemplateView,
	deleteDepositContractTemplate
} from '@api/storagemanage/DepositContractTemplate';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getDepositContractTemplateCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getDepositContractTemplateCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getDepositContractTemplateEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getDepositContractTemplateEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveDepositContractTemplate({}, DepositContractTemplate) {
			return new Promise((resolve, reject) => {
				saveDepositContractTemplate(DepositContractTemplate)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getDepositContractTemplateView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getDepositContractTemplateView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteDepositContractTemplate({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteDepositContractTemplate({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
